import { Form, FormProps } from "@/components/form";
import { z } from "zod/v4";

export const ventaAuthorizationCodeFormSchema = z.object({
    password: z.string().nonempty("Este campo es requerido")
})

export default function VentaAuthorizationCodeForm({
    form,
    ...props
}: FormProps<z.infer<typeof ventaAuthorizationCodeFormSchema>>) {
    return <Form form={form} gap={3} {...props}>
        <Form.PasswordField name="password" label="Contraseña" />
        <Form.SubmitButton>Autorizar</Form.SubmitButton>
    </Form>
}